import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.productConf',
    modules: [
        R,
    ],
})
@Service('ProductConfStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('product_configurations');
    }

    get uilist () {
        return this.list.filter(pc => pc.ui_location);
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/product.conf.js